import * as types from './actionTypes'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
    route: '',
    loading: false,
    errorText: '',
    keyword: '',
    orders: [],
    event: {},
})

export default function reduce(state = initialState, action = {}) {

    switch (action.type) {
        
        case types.ROUTE_SET:
            return state.merge({
                route: action.value,
            })

        case types.LOADING_SET:
            return state.merge({
                loading: action.value,
            })

        case types.EVENT_SET:
            return state.merge({
                event: action.value,
            })
        
        case types.ERROR_SET:
            return state.merge({
                errorText: action.value,
            })

        case types.KEYWORD_SET:
            return state.merge({
                keyword: action.value,
            })

        case types.ORDERS_SET:
            return state.merge({
                orders: action.value,
            })

        case types.PURCHASE_SET:
            return state.merge({
                purchase: action.value,
            })

        default:
            return state
    }
}

export function getRoute(state) {
    return state.adminCheck.route
}

export function getLoading(state) {
    return state.adminCheck.loading
}

export function getKeyword(state) {
    return state.adminCheck.keyword
}

export function getError(state) {
    return state.adminCheck.errorText
}

export function getEvent(state) {
    return state.adminCheck.event
}

export function getOrders(state) {
    return state.adminCheck.orders
}

export function getPurchase(state) {
    return state.adminCheck.purchase
}
